const errorHandler = {
    report: function(err) {
        return process.env.NODE_ENV === 'production' ? window.errorReporter?.report(err) : console.error(err)
    }
};

export default errorHandler;
